module.exports = __webpack_public_path__ + "fonts/bb3aa0a7-2585-4e89-ad82-658fd561751a.ca9d9591.eot";